export function strtolower(str) {
    //      discuss at: https://locutus.io/php/strtolower/
    // parity verified: PHP 8.3
    //     original by: Kevin van Zonneveld (https://kvz.io)
    //     improved by: Onno Marsman (https://twitter.com/onnomarsman)
    //       example 1: strtolower('Kevin van Zonneveld')
    //       returns 1: 'kevin van zonneveld'
    return (str + '').toLowerCase();
}
